import { SORT_FILTER_RESULTS_ATTR } from './FilteredLinkGate';

/**
 * Clearance under the pinned top bar is `scroll-margin-top` in cms.css; a later
 * call re-targets a scroll still running, so quick changes need no guard.
 */
export const scrollToResults = () =>
  document.querySelector(`[${SORT_FILTER_RESULTS_ATTR}]`)?.scrollIntoView({
    behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth',
    block: 'start',
  });
